import React, { FunctionComponent } from 'react'
import { t } from 'ttag'

import { PricingHosting } from './pricingTypes'

interface PlansTableHostingSwitchProps {
  modifier: `desktop` | `mobile`
  onChange: (hosting: PricingHosting) => void
  value: PricingHosting
}

const PlansTableHostingSwitch: FunctionComponent<PlansTableHostingSwitchProps> = ({
  modifier,
  onChange,
  value,
}) => (
  <div
    className={`PlansTable-switch PlansTable-switch--${modifier}`}
    role='group'
    aria-label='Pricing hosting'
  >
    <button
      className={`PlansTable-switch-tab${
        value === `cloud` ? ` PlansTable-switch-tab--active` : ``
      }`}
      type='button'
      aria-pressed={value === `cloud`}
      onClick={() => onChange(`cloud`)}
    >
      Cloud
    </button>
    <button
      className={`PlansTable-switch-tab${
        value === `on-premises` ? ` PlansTable-switch-tab--active` : ``
      }`}
      type='button'
      aria-pressed={value === `on-premises`}
      onClick={() => onChange(`on-premises`)}
    >
      {t`On-premises`}
    </button>
  </div>
)

export default PlansTableHostingSwitch
